export const apiBaseUrls = {
  localhost: 'http://localhost:3050/v1',
  develop: 'https://develop-api.dev.limehome.com/properties/v1',
  staging: 'https://staging-api.dev.limehome.com/properties/v1'
};
